import { Button } from '../../Elements';
import { useFormContext } from '../Form';

type SubmitButtonProps = {
	children: string;
	isDisabled?: boolean;
	isLoading?: boolean;
};

export const SubmitButton = ({ children, isDisabled, isLoading }: SubmitButtonProps) => {
	const form = useFormContext();

	return (
		<form.Subscribe
			selector={(state) => state.canSubmit}
			children={(canSubmit) => {
				return (
					<Button type='submit' disabled={!canSubmit || isDisabled} isLoading={isLoading}>
						{children}
					</Button>
				);
			}}
		></form.Subscribe>
	);
};
